<template>
	<Card>
	<div>
		<div class="sousuo" style="width: 100%">
			<div style="width: 450px" class="yl-flex flex_between">
				<Input  v-model="name" style="width: 300px">
				<i-button slot="append" icon="ios-search"></i-button>
				</Input>
				<Button class='ivu-btn-circle' type="primary" @click="getList">搜索</Button>
				<Button class='ivu-btn-circle' @click="initSearch">重置</Button>
			</div>
		
		</div>
		<div class="multiple">
			<div class="child-div">时间区间</div>
			<RadioGroup v-model="timePeriod">
				<Radio label="0"><span>不限</span></Radio>
				<Radio label="1"><span>今日</span></Radio>
				<Radio label="2"><span>昨日</span></Radio>
				<Radio label="3"><span>本周</span></Radio>
				<Radio label="4"><span>上周</span></Radio>
				<Radio label="5"><span>本月</span></Radio>
				<Radio label="6"><span>上月</span></Radio>
				<Radio label="7"><span>自定义</span></Radio>
				<DatePicker :value="timePeriodDate" @on-change="timePeriodDateChange" type="daterange"
							placeholder="选择日期" style="width: 200px"></DatePicker>

			</RadioGroup>
		</div>
		<div class="multiple">
			<div class="child-div">媒体渠道</div>
			<Select v-model="mediaChannel" @on-change="changeMedium" style="width:200px">
			        <Option v-for="item in mediaChannelList" :value="item.value" :key="item.value">{{ item.label }}</Option>
			</Select>
			<div class="child-div" style="margin-left: 20px;">媒体代码</div>
			<Select v-model="mediaValue" style="width:200px">
			        <Option v-for="item in mediaValueList" :value="item.value" :key="item.value">{{ item.label }}</Option>
			</Select>
		</div>
		<div class="multiple">
			<div class="child-div">下级渠道</div>
			<Select v-model="downChannel" style="width:200px">
			        <Option v-for="item in shopList" :value="item.value" :key="item.value">{{ item.label }}</Option>
			</Select>
		</div>

		<div  style="width: 100% ;margin-top: 20px;">
			<Table :columns="columns" :data="datas" size="small" ref="table">
			
			</Table>
		</div>
		
		
	</div>
	</Card>
</template>
<script>
	import {getAllMedium, getAllMediumCode, getAllShop, getCostCollect} from "../../api/runSet";
	import {mapGetters} from "vuex";

	export default {
		name: "cost_collect",
		components:{},
		
		data() {
			return {
				mediaChannel:'0',
				mediaChannelList:[
				],
				downChannel:'0',
				shopList:[
				],
				mediaValue:'0',
				mediaValueList:[
				],
				modal:false,
				count: 0,
				page: 1,
				name: '',
				timePeriod:'0',
				timePeriodDate: [],
				datas: [],
				columns: [
					{
							type: 'selection',
							width: 60,
							align: 'center'
						},
						{
							"title": "媒体代码",
							"key": "name",
						},
						{
							"title": "所属渠道",
							"key": "medium_name",
						},
					{
						"title": "类型",
						"key": "type_name",
					},
					{
						"title": "数量",
						"key": "nums",
					},
					{
						"title": "总计成本",
						"key": "cost",
					},
				],
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function () {
			this.loadData();
			this.getList();
		},
		methods: {

			timePeriodDateChange(e) {
				this.timePeriodDate = e
			},
			initSearch() {
				this.name = '';
				this.timePeriod = '0';
				this.timePeriodDate = [];
				this.mediaChannel = 0;
				this.mediaValue = 0;
				this.downChannel = 0;
			},
			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getAllMedium(that, data);
				that.mediaChannelList = res.data.list;
				res = await getAllShop(that, data);
				that.shopList = res.data.list;
			},
			async getList() {

				let that = this;
				var data = this.$data;
				data.token = this.token;
				let res = await getCostCollect(that, data);
				that.datas = res.data.list;
			},
			async changeMedium(e) {
				let that = this;
				let data = {}
				data.token = this.token;
				data.medium_id = e;
				let res = await getAllMediumCode(that, data);
				that.mediaValueList = res.data.list;
			},
		},





	}
</script>
<style scoped lang="less">
	.red{
		color: red;
	}
	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;
	
		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}
	.hong {
		color: #F56171;
		font-weight: bold;
	}

	.lan {
		color: #124386;
		font-weight: bold;
	}

	.sousuo {
		width: 100%;
		display: flex; 
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.ivu-table-header thead tr th {
		text-align: center !important;
	}

	.ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	.ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}
</style>
